import { CurrencyTryIcon } from './CurrencyTryIcon';

/**
 * author: Google
 * id 94DAFCB6-FA70-4DAE-B3DF-A107031F81E8
 * name currency-try
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-try.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const LiraIcon = CurrencyTryIcon;
export default LiraIcon